/* eslint-disable no-unused-vars */
import utils from '../../services/utils'
import { parse } from 'query-string'
import { v4 as uuid } from 'uuid'
import * as localForage from 'localforage'

import Visitor from './visitor.vue'
import User from './user.vue'
import AuthApi from '../../services/api/authApi.js'
import { mapGetters } from 'vuex'
import Session from '../../services/session'
import { shopifyApi } from '../../services/api/shopifyApi'

export default {
  components: {
    Visitor,
    User
  },
  data() {
    return {
      isUserLogged: false
    }
  },

  methods: {
    shopNow,
    toBuyer() {
      this.$router.push({ path: '/wholesale-retail/buyer' })
    },
    toBrand() {
      this.$router.push({ path: '/wholesale-retail/brand' })
    },
    openRegisterModal
  },

  mounted() {
    // RETAILER VERIFICATION
    // they have a email_verification_code (coming from signUpAsRetailer email)
    if (this.$route.query && this.$route.query.email_verification_code) {
      const AuthAPI = new AuthApi()
      const { email_verification_code } = this.$route.query
      // run the verify retailer request
      AuthAPI.verifyRetailer({ code: email_verification_code })
        //once the verification is a success redirect
        // to the signin page
        .then(() => {
          this.$trackEvent({ action: 'Email Verification', properties: { Success: true } })
          this.toast({
            type: 'succes',
            title: 'Success',
            message: 'You have successfully confirmed your email! You can now login!'
          })
          this.$router.push('sign-in')
        })
        .catch((error) => {
          this.$handleError(this, error)
        })
    } else if (this.$route.query && this.$route.query.brand_email_verification_code) {
      const AuthAPI = new AuthApi()
      const { brand_email_verification_code } = this.$route.query
      AuthAPI.verifyBrand({ code: brand_email_verification_code })
        .then(() => {
          this.$router.push('/accountConfirmed')
        })
        .catch((error) => {
          this.$handleError(this, error)
        })
    }
  },

  computed: {
    ...mapGetters({
      user: 'userState'
    })
  }
}

function openRegisterModal() {
  this.$eventBus.$emit('apply-modal-unregistered', null)
}

function shopNow() {
  this.$eventBus.$emit('show-promo-modal')
}
